// Tickets bought in one payment. A table stays 1: it is one ticket on the map
// however many people it seats.
export const ticketCount = (ticket) => (ticket?.quantity > 1 ? ticket.quantity : 1);

// What a ticket actually brought in: the amount paid (finalPrice), which is the
// ticket type's price minus any voucher discount. Tickets sold before that field
// existed, and admin-created ones, fall back to the ticket type's price — times
// the number of tickets in the order.
export const paidAmount = (ticket) => {
  if (typeof ticket?.finalPrice === "number") return ticket.finalPrice;
  return (ticket?.ticketTypeId?.price || 0) * ticketCount(ticket);
};

// "A-12, A-13" for an order of several seats, "A-12" for one, null for none
export const seatsLabel = (ticket) => {
  if (ticket?.seats?.length) {
    return ticket.seats.map(({ zone, number }) => `${zone}-${number}`).join(", ");
  }
  return ticket?.seatNumber ? `${ticket.seatZone}-${ticket.seatNumber}` : null;
};
